<template>
  <div id="hold">
    <h1 class="text-center">BlueChipCar Hold Model</h1>
    <h3 class="text-center pb-10">HOLD takes fractional ownership participation a step further with long term tangible asset investment and provides qualified majority shareowners the added benefit of shared custody rights.</h3>
    <ActiveHoldGrid></ActiveHoldGrid>

  </div>
</template>

<script>
  import ActiveHoldGrid from '../components/ActiveHoldGrid.vue'
  export default {
    name: 'Hold',

    components: {
      ActiveHoldGrid
    },
  }
</script>
